export class ObjectStore {
    db;
    id;
    constructor(db, id) {
        this.db = db;
        this.id = id;
    }
    async get(id) {
        return await this.db.getData(this.id, id);
    }
    async set(id, data) {
        return await this.db.setData(this.id, id, data);
    }
    async delete(id) {
        return await this.db.removeData(this.id, id);
    }
}
